/* eslint-disable no-console, no-use-before-define */
import _ from 'underscore';
import { getItemsFromAccount, removeItemFromAccount } from '../consumer-account/storage-actions';
import { getAssetSharingHtml } from '../../utils/social-media-sharing';
import { getIdFromAssetUrl } from '../widen-utils';
import { setTabFocus } from '../accessibility/tab-order';

_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g,
};

// Swatch and photo image item templates
const template =
  `<div class="col d-flex gallery-item gallery-item-image" id="photo-id-{{ assetId }}" data-src="{{ src }}" data-asset-id="{{ assetId }}">
    <div>
      <button type="button" class="gallery-modal-toggle" aria-expanded="false" aria-label="Show details for {{ src.substr((src.lastIndexOf('/') + 1)) }}">
        <img src="{{ thumb }}" alt="" />
      </button>
    </div>
  </div>`;

const noItemsTemplate =
  `<div class="row">
    <div class="col">
      <div class="rounded-box bg-gray p-5">
        {{ content }}
      </div>
    </div>
  </div>`;

const modalTemplate =
  `<div class="gallery-modal-container">
    <div>
      <div class="gallery-modal-caption">
        <button class="caption-titlebar" aria-expanded="true">
          <div class="caption-title">
            <span class="icon"></span>
            About this Photo
          </div>
        </button>
        <div class="caption-inner">
          <div class="caption-inner-left">
            <div class="body-regular">{{ description }}</div>
          </div>
          <div class="caption-inner-right">
            <div class="d-flex flex-row align-items-end">
              <div class="social-media-sharing"></div>
              <button class="btn-secondary favorites-item-btn btn-sm update-swatchbook-btn ml-4" data-asset-id="{{ assetId }}">
                <span class="icon"></span>
                Remove from Favorites
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>`;

const templateVals = _.template(template);
const noItemsTemplateVals = _.template(noItemsTemplate);
const modalTemplateVals = _.template(modalTemplate);
const modal = document.querySelector('.photo-modal-container');

let isCaptionMinimized = false;
let previousElementInFocus = null;
let items = [];

const props = {
  enqueuePdfUtilsData: null,
  getItemById: null,
  removePageItemById: null,
  updateSwatchbook: null,
};

const setPreviousElementInFocus = (element) => {
  previousElementInFocus = element;
  previousElementInFocus.setAttribute('aria-expanded', 'true');
};

const resetFocus = () => {
  if (previousElementInFocus) {
    previousElementInFocus.setAttribute('aria-expanded', 'false');
    previousElementInFocus.focus();
  }
};

const hasItems = () => (
  items.length !== 0
);

const update = () => {
  const { NoPhotosContent } = window;
  const div = document.createElement('div');
  const selector = document.querySelector('.photos-content');
  if (items.length === 0) {
    const compiled = noItemsTemplateVals({
      content: NoPhotosContent,
    });
    div.innerHTML = compiled;
    selector.innerHTML = '';
    selector.appendChild(div.firstChild);
  }
  props.updateSwatchbook();
};

const removeButtonHandler = (event) => {
  // console.log('swatchbook-photo.js, removeButtonHandler');
  let btn = event.target;
  if (!btn.classList.contains('update-swatchbook-btn')) {
    btn = btn.parentNode;
  }
  if (!btn.classList.contains('update-swatchbook-btn')) {
    btn = btn.parentNode;
  }
  if (!btn.classList.contains('update-swatchbook-btn')) {
    btn = btn.parentNode;
  }
  const assetId = btn.getAttribute('data-asset-id');
  removeItemFromAccount('photo', assetId, () => {
    // Remove lightgallery instance
    destroyLightGallery();
    // Remove photo
    const photo = document.getElementById(`photo-id-${assetId}`);
    photo.parentNode.removeChild(photo);
    props.removePageItemById(items, assetId);
    modal.querySelector('.update-swatchbook-btn').removeEventListener('click', removeButtonHandler);
    modal.removeChild(modal.firstChild);
    document.removeEventListener('click', removeModal); /* eslint-disable-line no-use-before-define */
    update();
    initLightGallery();
  });
};

const setCaptionPosition = () => {
  const captionDiv = modal.querySelector('.gallery-modal-caption');
  if (isCaptionMinimized) {
    captionDiv.style.bottom = `-${captionDiv.offsetHeight - 36}px`;
  } else {
    captionDiv.removeAttribute('style');
  }
};

const toggleCaptonTitlebar = () => {
  isCaptionMinimized = !isCaptionMinimized;
  const btn = modal.querySelector('.caption-titlebar');
  if (isCaptionMinimized) {
    btn.setAttribute('aria-expanded', 'false');
  } else {
    btn.setAttribute('aria-expanded', 'true');
  }
  setCaptionPosition();
};

const onModalWindowResize = () => {
  setCaptionPosition();
};

const removeModal = () => {
  if (modal.firstChild !== null) {
    modal.querySelector('.update-swatchbook-btn').removeEventListener('click', removeButtonHandler);
    modal.querySelector('.caption-titlebar').removeEventListener('click', toggleCaptonTitlebar);
    modal.removeChild(modal.firstChild);
    window.removeEventListener('resize', onModalWindowResize);
    resetFocus();
  }
};

const addModal = (data) => {
  removeModal();
  const div = document.createElement('div');
  const compiled = modalTemplateVals(data);
  div.innerHTML = compiled;
  modal.appendChild(div.firstChild);
  // Set focus state
  setPreviousElementInFocus(document.activeElement);
  // Tab order
  const lightGalleryCloseBtn = document.querySelector('.lg-close.lg-icon');
  const updateBtn = modal.querySelector('.update-swatchbook-btn');
  const captionTitlebar = modal.querySelector('.caption-titlebar');
  captionTitlebar.focus();
  setTabFocus({
    element: updateBtn,
    nextElement: lightGalleryCloseBtn,
  });
  setTabFocus({
    element: lightGalleryCloseBtn,
    prevElement: updateBtn,
  });
  // Add social media shares
  const socialMediaSharingWrapper = modal.querySelector('.social-media-sharing');
  socialMediaSharingWrapper.innerHTML = getAssetSharingHtml(data);
  isCaptionMinimized = false;
  // on-resize
  window.addEventListener('resize', onModalWindowResize);
  modal.querySelector('.update-swatchbook-btn').addEventListener('click', removeButtonHandler);
  modal.querySelector('.caption-titlebar').addEventListener('click', toggleCaptonTitlebar);
};

const updateModal = (event) => {
  const liIndex = event.detail.index;
  const lgDiv = document.querySelector('.media-gallery-list');
  const liItem = lgDiv.querySelectorAll('.gallery-item')[liIndex];
  const assetId = liItem.getAttribute('data-asset-id');
  const item = props.getItemById(items, assetId);
  addModal(item);
};

const destroyLightGallery = () => {
  const { lgData } = window;
  const lgDiv = document.querySelector('.media-gallery-list');
  const lgUid = lgData[lgDiv.getAttribute('lg-uid')];
  if (lgUid) {
    lgDiv.removeEventListener('onAfterSlide', updateModal);
    lgDiv.removeEventListener('onCloseAfter', removeModal);
    lgUid.destroy(true);
  }
};

const initLightGallery = () => {
  const { lightGallery } = window;
  const lgDiv = document.querySelector('.media-gallery-list');
  if (lgDiv === null) {
    return;
  }
  lightGallery(lgDiv, {
    counter: false,
    download: false,
    preload: 3,
    selector: '.gallery-item',
    share: false,
    speed: 250,
  });
  lgDiv.addEventListener('onAfterSlide', updateModal);
  lgDiv.addEventListener('onCloseAfter', removeModal);
};

const onLoaded = (data) => {
  const { PhotoShareUrl, location } = window;
  const { origin } = location;
  // console.log(data);
  // Map data
  items = data.photos.map(item => ({
    src: item['photo-url'],
    assetId: item['photo-id'],
    shareLink: encodeURIComponent(`${origin}${PhotoShareUrl}#${getIdFromAssetUrl(item['photo-url'])}`),
    thumb: item['thumbnail-url'],
    description: item.description,
    productLineName: item['product-line-name'],
    productLineId: item['product-line-id'],
    type: 'photo', // for pdfutils,
    imageUrl: item['photo-url'], // for pdfutils
    id: getIdFromAssetUrl(item['photo-url']), // for pdfutils
  }));
  // Display saved content
  if (items.length > 0) {
    const selector = document.querySelector('.photos-content');
    const div = document.createElement('div');
    div.classList = 'row row-cols-3 row-cols-sm-4 row-cols-md-5 mx-0 media-gallery-list';
    selector.innerHTML = '';
    items.forEach((item) => {
      const itemDiv = document.createElement('div');
      const compiled = templateVals(item);
      itemDiv.innerHTML = compiled;
      div.appendChild(itemDiv.firstChild);
    });
    selector.appendChild(div);
  }
  props.enqueuePdfUtilsData(items);
  update();
  initLightGallery();
};

const init = (options) => {
  const {
    enqueuePdfUtilsData,
    getItemById,
    removePageItemById,
    updateSwatchbook,
  } = options;
  props.enqueuePdfUtilsData = enqueuePdfUtilsData;
  props.getItemById = getItemById;
  props.removePageItemById = removePageItemById;
  props.updateSwatchbook = updateSwatchbook;
  getItemsFromAccount('photo', onLoaded);
};

export {
  hasItems,
  init,
  onLoaded,
};
/* eslint-enable no-console, no-use-before-define */
